import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function BrandLevel({ idVariant = '', className }: Props) {
  return (
    <IconBase name="brand-level" w={88} h={21} className={className}>
      <g clipPath={`url(#brandlevel_${idVariant}_clip0_382_1063)`}>
        <path d="M1.43822 0.53833H0V20.4799H13.3455V19.0563H1.43822V0.53833Z" fill="currentColor" />
        <path
          d="M86.5628 19.0563V0.53833H88.001V20.4799H74.6592V19.0563H86.5628Z"
          fill="currentColor"
        />
        <path
          d="M43.9169 18.3008L36.2695 0.764716L36.1454 0.483643H34.5977L43.3255 20.48H44.5082L53.2543 0.483643H51.703L43.9169 18.3008Z"
          fill="currentColor"
        />
        <path
          d="M30.9144 0.47998H18.6494V3.08995H30.9144V0.47998Z"
          className="c2"
          fill="currentColor"
        />
        <path
          d="M30.9144 10.0986H18.6494V12.0552H30.9144V10.0986Z"
          className="c2"
          fill="currentColor"
        />
        <path
          d="M30.9144 19.0674H18.6494V20.4801H30.9144V19.0674Z"
          className="c2"
          fill="currentColor"
        />
        <path
          d="M69.1185 0.47998H56.8535V3.08995H69.1185V0.47998Z"
          className="c2"
          fill="currentColor"
        />
        <path
          d="M69.1185 10.0986H56.8535V12.0552H69.1185V10.0986Z"
          className="c2"
          fill="currentColor"
        />
        <path
          d="M69.1185 19.0674H56.8535V20.4801H69.1185V19.0674Z"
          className="c2"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={`brandlevel_${idVariant}_clip0_382_1063`}>
          <rect width="88.0015" height="20" fill="currentColor" transform="translate(0 0.47998)" />
        </clipPath>
      </defs>
    </IconBase>
  )
}

export default BrandLevel
